// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[basic-loading][data-v-4a24d7ec] .el-loading-mask{--tw-bg-opacity:1;background-color:#0e0e0e;background-color:rgba(14,14,14,var(--tw-bg-opacity))}[basic-loading][data-v-4a24d7ec] .el-loading-spinner{display:flex;justify-content:center}[basic-loading][data-v-4a24d7ec] .el-loading-spinner .circular{height:5rem;width:5rem}[basic-loading][data-v-4a24d7ec] .el-loading-spinner .path{stroke:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
